import { render } from "./CoinsHandIcon.vue?vue&type=template&id=5f91b781"
import script from "./CoinsHandIcon.vue?vue&type=script&lang=js"
export * from "./CoinsHandIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__